import { c as _c } from "react/compiler-runtime";
import type { IconProps } from './Icon.types';
import { IconWrapper } from './IconWrapper';
const Bus = t0 => {
  const $ = _c(12);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="M13.2802 1.77782C13.2802 1.196 12.8269 1.10442 12.5602 1.13135H3.44021C3.20021 1.13136 2.72021 1.26065 2.72021 1.77782V12.6061C2.72021 12.7677 2.81621 13.0909 3.20021 13.0909H12.8002C12.9602 13.0909 13.2802 12.994 13.2802 12.6061V1.77782Z" />;
    t2 = <path d="M10.3999 13.0103V14.6264C10.3999 14.8204 10.5866 14.8689 10.6399 14.8689H12.0799C12.1599 14.8689 12.3199 14.8204 12.3199 14.6264V13.0103" />;
    t3 = <path d="M3.68018 13.0103V14.6264C3.68018 14.8204 3.86684 14.8688 3.92018 14.8688H5.36018C5.44018 14.8688 5.60018 14.8204 5.60018 14.6264V13.0103" />;
    t4 = <path d="M3.2002 4.47998H12.8002M12.8002 7.67998H3.2002" />;
    t5 = <path d="M8 4.59961V7.79961" />;
    t6 = <ellipse cx="5.51982" cy="10.3642" rx="1.2" ry="1.21212" />;
    t7 = <ellipse cx="10.4798" cy="10.3642" rx="1.2" ry="1.21212" />;
    t8 = <path d="M6.87988 2.75H9.11988" strokeLinecap="round" />;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
    $[7] = t6;
    $[8] = t7;
    $[9] = t8;
  } else {
    t1 = $[2];
    t2 = $[3];
    t3 = $[4];
    t4 = $[5];
    t5 = $[6];
    t6 = $[7];
    t7 = $[8];
    t8 = $[9];
  }
  let t9;
  if ($[10] !== props) {
    t9 = <IconWrapper {...props} variant="outline" viewBox="0 0 16 16" strokeWidth={1}>{t1}{t2}{t3}{t4}{t5}{t6}{t7}{t8}</IconWrapper>;
    $[10] = props;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  return t9;
};
export { Bus };